// extracted by mini-css-extract-plugin
module.exports = {"carousel":"w_L","large":"w_M"};